const Constants = {
	NEW_ID: 0,
	EMPTY_ID: -1,
	ALL: '*',
	NEW_ID_STRING: '0'
}

export default Constants


// WEBPACK FOOTER //
// ./src/common/constants.js